var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolTipHoverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emojione-monotone:letter-i",
    clipPath: "url(#clip0_2026_7778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 0.3125C2.41125 0.3125 0.3125 2.41109 0.3125 5C0.3125 7.58891 2.41125 9.6875 5 9.6875C7.58875 9.6875 9.6875 7.58875 9.6875 5C9.6875 2.41109 7.58875 0.3125 5 0.3125ZM5.47062 7.26687H4.52953V2.73313H5.47062V7.26687Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2026_7778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolTipHoverIcon);
export default __webpack_public_path__ + "static/media/tool_tip_hover_icon.46f7cc74d67e6a91fc1578cc832525de.svg";
export { ForwardRef as ReactComponent };